module.exports = __webpack_public_path__ + "media/images/home/icon-star-accent-787f8cf1da7967ba9dada1a837d96259.svg";